// export const API=`http://localhost:5000`;
export const API=`https://e-commerce-website-xwq6.onrender.com`